/**
 * 页面注册表：只按名称配置「有组件的页面」.
 * 格式：name -> { component } 或 name -> { component, path }（path 与 name 不同时才写）
 * 父级菜单（ums、shop 等）无需配置，后端菜单树 + name 自动作为 Layout 路径
 * 注：编辑/添加等隐藏页（如 updateMenu、addMenu）需在后端菜单表中存在并分配给角色，否则对应路由不会注册，点编辑会 404
 */
export default {
  home: {
    component: () => import('@/views/home/index.vue')
  },
  admin: {
    component: () => import('@/views/ums/admin/index.vue')
  },
  role: {
    component: () => import('@/views/ums/role/index.vue')
  },
  allocMenu: {
    component: () => import('@/views/ums/role/allocMenu.vue')
  },
  allocResource: {
    component: () => import('@/views/ums/role/allocResource.vue')
  },
  menu: {
    component: () => import('@/views/ums/menu/index.vue')
  },
  addMenu: {
    component: () => import('@/views/ums/menu/add.vue')
  },
  updateMenu: {
    component: () => import('@/views/ums/menu/update.vue')
  },
  resource: {
    component: () => import('@/views/ums/resource/index.vue')
  },
  resourceCategory: {
    component: () => import('@/views/ums/resource/categoryList.vue')
  },
  list: {
    component: () => import('@/views/shop/list/index.vue')
  },
  shopPermissionList: {
    path: 'permission',
    component: () => import('@/views/shopPermission/permission/index.vue')
  },
  shopVersionList: {
    path: 'version',
    component: () => import('@/views/shop/version/index.vue')
  },
  shopTypeList: {
    path: 'shopType',
    component: () => import('@/views/shop/shopType/index.vue')
  },
  shopTypeProduct: {
    path: 'shopType/product',
    component: () => import('@/views/shop/shopType/product/index.vue')
  },
  shopTypePosition: {
    path: 'shopType/position',
    component: () => import('@/views/shop/shopType/position/index.vue')
  },
  renew: {
    component: () => import('@/views/shop/renew/index.vue')
  },
  feedback: {
    component: () => import('@/views/feedback/index.vue')
  },
  helpCenter: {
    component: () => import('@/views/helpCenter/index.vue')
  },
  smsSendLog: {
    component: () => import('@/views/smsSendLog/index.vue')
  },
  systemConfig: {
    path: 'config',
    component: () => import('@/views/systemConfig/index.vue')
  },
  verCodeWhitelist: {
    path: 'verCodeWhitelist',
    component: () => import('@/views/verCodeWhitelist/index.vue')
  },
  clientVersion: {
    path: 'clientVersion',
    component: () => import('@/views/clientVersion/index.vue')
  },
  policyConfig: {
    path: 'policy',
    component: () => import('@/views/policyConfig/index.vue')
  },
  logSmsSendLog: {
    path: 'smsSendLog',
    component: () => import('@/views/smsSendLog/index.vue')
  },
  sysLog: {
    component: () => import('@/views/sysLog/index.vue')
  },
  logSysLog: {
    path: 'sysLog',
    component: () => import('@/views/sysLog/index.vue')
  }
}



// WEBPACK FOOTER //
// ./src/router/pageRegistry.js